import React from "react";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import {
  avatar__container,
  avatar__img,
  chat__container,
  chat__text,
  chat__text__bubble,
  chat__text__container,
  chat__text__footer__container,
  chat__text__footer__time,
  chat__text__wrapper,
} from "./style";

export default function TextMessage({
  align = "LEFT",
  text = "",
  time = "",
  avatarImageUrl = "",
  showAvatarImage = false,
  isRead = false,
  sending = false,
  failed = false,
}) {
  align = align
    ? ["LEFT", "RIGHT"].includes(align.toUpperCase())
      ? align.toUpperCase()
      : "LEFT"
    : "LEFT";
  return (
    <>
      <Box sx={chat__container}>
        <Box sx={avatar__container}>
          {align === "LEFT" && showAvatarImage === true ? (
            <LazyLoadImage
              src={avatarImageUrl ? avatarImageUrl : "/assets/icons/avatar.svg"}
              alt="avatar"
              style={avatar__img}
            ></LazyLoadImage>
          ) : (
            ""
          )}
        </Box>
        <Box sx={chat__text__wrapper}>
          <Box
            sx={{
              ...chat__text__container,
              justifyContent: align === "LEFT" ? "start" : "end",
            }}
          >
            <Box
              sx={{
                ...chat__text__bubble,
                background: align === "LEFT" ? "#EFF1F9" : "#FFF1F9",
                borderRadius:
                  align === "LEFT" ? "0px 8px 8px 8px" : "8px 0px 8px 8px",
              }}
            >
              <Typography
                component={"p"}
                sx={{
                  ...chat__text,
                  pl: align === "LEFT" ? 0.5 : 0,
                }}
              >
                {text}
              </Typography>
              <Box sx={chat__text__footer__container}>
                <Typography sx={chat__text__footer__time}>
                  {sending ? (failed ? "gagal mengirim" : "mengirim...") : time}
                </Typography>
                {sending ? (
                  <></>
                ) : align === "RIGHT" ? (
                  <LazyLoadImage
                    style={{
                      width: "12px",
                      height: "12px",
                    }}
                    src={
                      isRead
                        ? "/assets/chat/double-check-blue.png"
                        : "/assets/chat/double-check.png"
                    }
                  ></LazyLoadImage>
                ) : (
                  <></>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box sx={avatar__container}>
          {align === "RIGHT" && showAvatarImage === true ? (
            <LazyLoadImage
              src={avatarImageUrl ? avatarImageUrl : "/assets/icons/avatar.svg"}
              alt="avatar"
              style={avatar__img}
            ></LazyLoadImage>
          ) : (
            ""
          )}
        </Box>
      </Box>
    </>
  );
}
